import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  proceedToNextFormStep,
  goBack,
} from "../../../actions/diversityFormActions";
import RadioButton from "../../shared/publicForms/RadioButton";
import {
  StepWrapper,
  Title,
  ButtonsWrapper,
  BackButton,
  Button,
  DisabledButton,
  RadioButtonGroupWrapper,
  RadioButtonGroup,
} from "../styles/diversity-form-styles";

export interface IDisabilityProps {
  values: {
    disability?: null | string;
  };
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
  goBackAction: typeof goBack;
}

export const Disability: FunctionComponent<IDisabilityProps> = ({
  proceedToNextFormStepAction,
  values,
  goBackAction,
}) => {
  const radioButtonOptions = ["Yes", "No", "Prefer not to say"];

  return (
    <StepWrapper data-test-id="disability-step" formStep>
      <Title data-test-id="title">
        Would you say that you have a disability?
      </Title>
      <RadioButtonGroupWrapper
        role="group"
        aria-labelledby="disability-radio-group"
      >
        <RadioButtonGroup width={185}>
          {radioButtonOptions.map((option) => (
            <Field
              key={option}
              name="disability"
              type="radio"
              aria-label={option}
              label={option}
              value={option}
              as={RadioButton}
            />
          ))}
        </RadioButtonGroup>
      </RadioButtonGroupWrapper>
      <ButtonsWrapper>
        <BackButton type="button" onClick={goBackAction}>
          <FontAwesomeIcon icon={faChevronLeft} />
          back
        </BackButton>
        {values.disability ? (
          <Button
            type="button"
            onClick={proceedToNextFormStepAction}
            data-test-id="next-button"
          >
            Next
          </Button>
        ) : (
          <DisabledButton type="button">Next</DisabledButton>
        )}
      </ButtonsWrapper>
    </StepWrapper>
  );
};

Disability.propTypes = {
  values: PropTypes.shape({
    disability: PropTypes.string,
  }).isRequired,
  proceedToNextFormStepAction: PropTypes.func.isRequired,
  goBackAction: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
  goBackAction: goBack,
})(Disability);
